/* KAV · Conversor de moneda por IP
   Reemplazo propio de la app de monedas. Solo cambia lo que se VE:
   la tienda sigue cobrando en dolares en el checkout.
   - Detecta el pais del visitante por IP (solo la primera vez, despues respeta su eleccion).
   - Tasa de cambio: open.er-api.com, una consulta al dia, guardada en el navegador.
   - Convierte los precios del tema y se mantiene al dia cuando el tema los reescribe.
   - Selector manual con bandera, con opcion de volver a automatico.
   - Para probar: agregar ?kavmoneda=CRC a cualquier direccion.
*/
(function () {
  var MONEDA_TIENDA = "USD";
  var CLAVE_GUARDADA = "kav_moneda";
  var CLAVE_TASAS = "kav_tasas";
  var HORAS_CACHE = 12;
  var API_TASAS = "https://open.er-api.com/v6/latest/USD";
  var API_IP = "https://get.geojs.io/v1/ip/country.json";

  // las mas usadas primero, para que no queden enterradas en la lista
  var MONEDAS = ["USD","CRC","CAD","MXN","GTQ","HNL","NIO","PAB","DOP","TTD","JMD","BRL","COP",
                 "PEN","CLP","ARS","PYG","UYU","BOB","EUR","GBP","CHF","SEK","NOK","DKK","PLN",
                 "CZK","HUF","RON","BGN","TRY","AUD","NZD","JPY","KRW","CNY","HKD","SGD","TWD",
                 "THB","MYR","IDR","PHP","INR","VND","AED","SAR","QAR","ILS","KWD","ZAR","EGP",
                 "NGN","KES","MAD"];

  var SIN_DECIMALES = { "BIF":1,"CLP":1,"DJF":1,"GNF":1,"ISK":1,"JPY":1,"KMF":1,"KRW":1,"PYG":1,"RWF":1,"UGX":1,"VND":1,"VUV":1,"XAF":1,"XOF":1,"XPF":1 };

  var BANDERA = { ARS:"🇦🇷", AUD:"🇦🇺", CAD:"🇨🇦", CHF:"🇨🇭", CLP:"🇨🇱", CNH:"🇨🇳", CNY:"🇨🇳", COP:"🇨🇴", CRC:"🇨🇷",
                  CZK:"🇨🇿", DJF:"🇩🇯", DKK:"🇩🇰", DOP:"🇩🇴", EGP:"🇪🇬", EUR:"🇪🇺", GBP:"🇬🇧", GTQ:"🇬🇹", GYD:"🇬🇾",
                  HKD:"🇭🇰", HNL:"🇭🇳", JPY:"🇯🇵", MXN:"🇲🇽", NIO:"🇳🇮", NZD:"🇳🇿", PAB:"🇵🇦", PEN:"🇵🇪", PHP:"🇵🇭",
                  PYG:"🇵🇾", QAR:"🇶🇦", RON:"🇷🇴", RSD:"🇷🇸", RUB:"🇷🇺", RWF:"🇷🇼", SAR:"🇸🇦", SDG:"🇸🇩", SEK:"🇸🇪",
                  SGD:"🇸🇬", SVC:"🇸🇻", TTD:"🇹🇹", TWD:"🇹🇼", USD:"🇺🇸" };

  var NOMBRE = { CRC:"Costa Rican Colón", USD:"US Dollar", EUR:"Euro", MXN:"Mexican Peso", CAD:"Canadian Dollar",
                 GBP:"British Pound", AUD:"Australian Dollar", JPY:"Japanese Yen", BRL:"Brazilian Real" };

  var PAIS_MONEDA = { CR:"CRC", US:"USD", CA:"CAD", MX:"MXN", GB:"GBP", AU:"AUD", NZ:"NZD", JP:"JPY", CH:"CHF",
                      CN:"CNY", HK:"HKD", SG:"SGD", TW:"TWD", KR:"USD", IN:"USD", AE:"USD", SA:"SAR", QA:"QAR",
                      PA:"PAB", GT:"GTQ", HN:"HNL", NI:"NIO", SV:"USD", BZ:"USD", DO:"DOP", TT:"TTD", GY:"GYD",
                      CO:"COP", PE:"PEN", CL:"CLP", AR:"ARS", PY:"PYG", BR:"USD", BO:"USD", EC:"USD", VE:"USD",
                      EG:"EGP", DJ:"DJF", RW:"RWF", SD:"SDG", RS:"RSD", RO:"RON", RU:"RUB", CZ:"CZK", DK:"DKK",
                      SE:"SEK", NO:"USD", PH:"PHP" };
  // Respaldo: si el IP no da un pais utilizable (por ejemplo si la conexion sale por otro pais),
  // se mira la zona horaria y el idioma del navegador.
  var TZ_PAIS = { "Costa_Rica":"CR", "Guatemala":"GT", "El_Salvador":"SV", "Honduras":"HN", "Nicaragua":"NI",
                  "Panama":"PA", "Mexico":"MX", "Colombia":"CO", "Peru":"PE", "Chile":"CL", "Argentina":"AR",
                  "Uruguay":"UY", "Paraguay":"PY", "Bolivia":"BO", "Ecuador":"EC", "Venezuela":"VE",
                  "Santo_Domingo":"DO", "Puerto_Rico":"PR", "Madrid":"ES", "Paris":"FR", "Berlin":"DE",
                  "Rome":"IT", "Lisbon":"PT", "London":"GB", "Dublin":"IE", "Amsterdam":"NL", "Brussels":"BE",
                  "Vienna":"AT", "Zurich":"CH", "Stockholm":"SE", "Oslo":"NO", "Copenhagen":"DK", "Helsinki":"FI",
                  "Warsaw":"PL", "Prague":"CZ", "Athens":"GR", "Toronto":"CA", "Vancouver":"CA", "Sao_Paulo":"BR",
                  "Tokyo":"JP", "Sydney":"AU", "Auckland":"NZ", "Singapore":"SG", "Hong_Kong":"HK", "Taipei":"TW" };

  function monedaPorNavegador() {
    var alternativas = [];
    try {
      var tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || "").split("/").pop();
      if (tz && TZ_PAIS[tz]) alternativas.push(TZ_PAIS[tz]);
    } catch (e) {}
    var idioma = navigator.language || navigator.userLanguage || "";
    var m = idioma.match(/[-_]([A-Za-z]{2})$/);
    if (m) alternativas.push(m[1].toUpperCase());
    for (var i = 0; i < alternativas.length; i++) {
      var mon = monedaPorPais(alternativas[i]);
      if (mon && mon !== "USD") return mon;
    }
    return null;
  }

  var EUROPA = ["DE","FR","ES","IT","NL","PT","IE","BE","AT","FI","GR","LU","SK","SI","LV","LT","EE","MT","CY","HR"];

  var tasas = null, monedaActiva = null, originales = new WeakMap(), observando = false;

  // La eleccion se guarda con JSON.stringify, asi que hay que deserializarla al leerla.
  // Toleramos tambien el valor crudo ("USD" sin comillas) por si quedo de una version previa.
  function leerGuardada() {
    var v = null;
    try { v = localStorage.getItem(CLAVE_GUARDADA); } catch (e) { return null; }
    if (v == null) return null;
    try { v = JSON.parse(v); } catch (e) { v = String(v); }
    v = String(v == null ? "" : v).replace(/^"|"$/g, "").trim().toUpperCase();
    return /^[A-Z]{3}$/.test(v) ? v : null;
  }

  function leer(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function guardar(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  function monedaPorPais(codigo) {
    if (!codigo) return null;
    if (EUROPA.indexOf(codigo) > -1) return "EUR";
    return PAIS_MONEDA[codigo] || null;
  }

  var SIMBOLO = { USD:"$", CRC:"\u20a1", EUR:"\u20ac", GBP:"\u00a3", JPY:"\u00a5", CNY:"\u00a5", CNH:"CNH ",
                  MXN:"MX$", CAD:"CA$", AUD:"A$", NZD:"NZ$", CHF:"CHF ", HKD:"HK$", SGD:"S$", TWD:"NT$",
                  CLP:"CLP$", COP:"COP$", ARS:"AR$", PEN:"S/ ", UYU:"$U ", GTQ:"Q", HNL:"L", NIO:"C$",
                  PAB:"B/. ", DOP:"RD$", TTD:"TT$", GYD:"G$", SVC:"SVC$", PHP:"\u20b1", SEK:"kr ", DKK:"kr ",
                  NOK:"kr ", CZK:"K\u010d ", RON:"lei ", RSD:"din ", RUB:"\u20bd", INR:"\u20b9" };

  function agrupar(numero, decimales) {
    var partes = Math.abs(numero).toFixed(decimales).split(".");
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return (numero < 0 ? "-" : "") + partes.join(",");
  }

  function formato(valor, moneda) {
    var dec = SIN_DECIMALES[moneda] ? 0 : 2;
    var sim = SIMBOLO[moneda];
    var cuerpo = agrupar(valor, dec);
    if (sim === undefined) return cuerpo + " " + moneda;
    return sim + cuerpo;
  }

  /* ---------- conversion de precios ----------
     El tema parte cada precio en pedazos (el "$" en un span, el entero aparte y
     los decimales en un <sup>), asi que no alcanza con mirar textos sueltos:
     hay que leer el precio completo de cada contenedor y volver a escribirlo. */
  var RE_PRECIO = /\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+(?:\.\d{2})?)/g;
  // Solo se toca el elemento que contiene el precio en si (el <bdi> del tema),
  // nunca el contenedor grande, porque ahi viven los textos ocultos de accesibilidad
  // ("Regular price", "Sale price") y reemplazarlos los haria visibles.
  var RE_CONTENEDOR = "bdi, .price__container, .money, .price-item";
  var NO_ENTRAR = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|CODE|PRE|SUP)$/;
  var originales = new WeakMap();        // nodos de texto
  var originalesHTML = new WeakMap();    // contenedores de precio

  function textoDe(el) {
    var original = originalesHTML.get(el);
    var fuente = original === undefined ? el.innerHTML : original;
    var tmp = document.createElement("div");
    tmp.innerHTML = fuente;
    return (tmp.textContent || "").replace(/\s+/g, " ").trim();
  }

  function convertirCadena(texto) {
    if (monedaActiva === MONEDA_TIENDA || !tasas || !tasas[monedaActiva]) return null;
    var tasa = tasas[monedaActiva];
    var hubo = false;
    var salida = texto.replace(RE_PRECIO, function (todo, num) {
      var valor = parseFloat(num.replace(/,/g, ""));
      if (!isFinite(valor)) return todo;
      hubo = true;
      return formato(valor * tasa, monedaActiva);
    });
    // el codigo de la moneda de la tienda va pegado al precio (ej. "$69.90 USD")
    if (hubo) salida = salida.replace(/\bUSD\b/g, monedaActiva);
    return hubo ? salida : null;
  }

  // Convierte respetando la estructura del tema: el simbolo va en su span,
  // los decimales en su <sup> y el entero en el texto de en medio. Asi el tamano
  // grande del numero y los centavos chiquitos se mantienen como los disena el tema.
  function convertirElementoPrecio(el) {
    var original = originalesHTML.get(el);
    if (original === undefined) { original = el.innerHTML; originalesHTML.set(el, original); }

    var volver = (monedaActiva === MONEDA_TIENDA || !tasas || !tasas[monedaActiva]);
    if (volver) {
      if (el.getAttribute("data-kav-precio")) { el.innerHTML = original; el.removeAttribute("data-kav-precio"); }
      return;
    }

    var tmp = document.createElement("div");
    tmp.innerHTML = original;
    var texto = (tmp.textContent || "").replace(/\s+/g, " ").trim();
    var m = texto.match(/\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+(?:\.\d{2})?)/);
    if (!m) return;
    var valor = parseFloat(m[1].replace(/,/g, ""));
    if (!isFinite(valor)) return;

    var dec = SIN_DECIMALES[monedaActiva] ? 0 : 2;
    var cuerpo = agrupar(valor * tasas[monedaActiva], dec);   // 15.982,77
    var partes = dec > 0 ? cuerpo.split(",") : [cuerpo, ""];
    var entero = partes[0];
    var decimales = dec > 0 ? "," + partes[1] : "";
    var sim = SIMBOLO[monedaActiva] === undefined ? monedaActiva + " " : SIMBOLO[monedaActiva];

    var pre = el.querySelector(".price__prefix");
    var sup = el.querySelector(".price__suffix");
    if (pre || sup) {
      if (pre) pre.textContent = sim;
      if (sup) sup.textContent = decimales;
      var nodo = null;
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var pn = n.parentNode;
        if (pn && (pn.classList.contains("price__prefix") || pn.classList.contains("price__suffix"))) continue;
        if (n.nodeValue && n.nodeValue.trim()) { nodo = n; break; }
      }
      if (nodo) nodo.nodeValue = entero;
      else el.insertBefore(document.createTextNode(entero), el.firstChild);
    } else {
      el.textContent = formato(valor * tasas[monedaActiva], monedaActiva);
    }
    el.setAttribute("data-kav-precio", "1");
  }

  function recorrerElementos(raiz) {
    var els = raiz.querySelectorAll ? raiz.querySelectorAll(RE_CONTENEDOR) : [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      // el filtro anti-duplicados solo aplica al convertir, nunca al restaurar
      if (monedaActiva !== MONEDA_TIENDA && el.parentElement && el.parentElement.closest && el.parentElement.closest("[data-kav-precio]")) continue;
      if (el.querySelector && el.querySelector(".visually-hidden, .sr-only")) continue;
      convertirElementoPrecio(el);
    }
  }

  // Para textos sueltos (por ejemplo el aviso de envio gratis de la barra de arriba).
  // El valor original en dolares se guarda en el propio elemento, porque el tema
  // vuelve a dibujar esa barra copiando el texto ya convertido.
  function convertirTexto(nodo) {
    var host = nodo.parentNode;
    // el codigo de moneda se atiende primero: "USD" pasa al codigo activo y vuelve solo
    if (/^\s*USD\s*$/.test(nodo.nodeValue || "")) {
      if (monedaActiva === MONEDA_TIENDA) { if (nodo.nodeValue !== "USD") nodo.nodeValue = "USD"; }
      else if (nodo.nodeValue !== monedaActiva) nodo.nodeValue = monedaActiva;
      return;
    }
    if (!host || !host.setAttribute) { convertirNodoSuelto(nodo); return; }

    // si el elemento tiene un solo texto adentro, se maneja como una unidad
    if (host.childNodes.length === 1) {
      var usd = host.getAttribute("data-kav-usd");
      if (usd === null) {
        if (!/\$\s?\d/.test(nodo.nodeValue || "")) return;
        usd = nodo.nodeValue;
        host.setAttribute("data-kav-usd", usd);
      }
      var nuevo = convertirCadena(usd);
      if (nuevo === null) {
        if (host.textContent !== usd) host.textContent = usd;
        return;
      }
      if (host.textContent !== nuevo) host.textContent = nuevo;
      return;
    }
    convertirNodoSuelto(nodo);
  }

  function convertirNodoSuelto(nodo) {
    var host = nodo.parentNode;
    var original = originales.get(nodo);
    if (original === undefined) { original = nodo.nodeValue; originales.set(nodo, original); }
    // marca el elemento con el valor original para que el texto siga visitandose
    if (host && host.setAttribute && host.getAttribute("data-kav-usd") === null) host.setAttribute("data-kav-usd", original);
    // el codigo de moneda: "USD" pasa al codigo activo y vuelve solo
    if (/^\s*USD\s*$/.test(original)) {
      if (monedaActiva === MONEDA_TIENDA) { if (nodo.nodeValue !== "USD") nodo.nodeValue = "USD"; }
      else if (nodo.nodeValue !== monedaActiva) nodo.nodeValue = monedaActiva;
      return;
    }
    var nuevo = convertirCadena(original);
    if (nuevo === null) {
      if (monedaActiva === MONEDA_TIENDA && nodo.nodeValue !== original) nodo.nodeValue = original;
      return;
    }
    if (nodo.nodeValue !== nuevo) nodo.nodeValue = nuevo;
  }

  function recorrerRaizTextos(raiz) {
    if (!raiz) return;
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || NO_ENTRAR.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        if (p.closest && (p.closest("[data-kav-moneda-ui]") || p.closest("[data-kav-precio]"))) return NodeFilter.FILTER_REJECT;
        if (p.closest && p.closest("bdi, .price__container, .price-item")) return NodeFilter.FILTER_REJECT;
        var esCodigo = /^\s*USD\s*$/.test(n.nodeValue);
        // Un texto ya convertido no contiene "$", pero su elemento guarda el valor original.
        // Hay que volver a visitarlo para que el cambio de moneda se refleje al instante.
        var yaConvertido = !!(p.getAttribute && p.getAttribute("data-kav-usd") !== null);
        var esPrecio = n.nodeValue.indexOf("$") !== -1 || yaConvertido;
        if (!esPrecio && !esCodigo) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = w.nextNode())) convertirTexto(n);
  }

  function raices() {
    var lista = [document.body], i = 0;
    while (i < lista.length && i < 4000) {
      var actual = lista[i++];
      var els = actual.querySelectorAll ? actual.querySelectorAll("*") : [];
      for (var j = 0; j < els.length; j++) if (els[j].shadowRoot) lista.push(els[j].shadowRoot);
    }
    return lista;
  }

  function recorrer() {
    var rs = raices();
    for (var i = 0; i < rs.length; i++) {
      recorrerElementos(rs[i]);
      recorrerRaizTextos(rs[i]);
    }
  }

  // El cajon del carrito de este tema: <cart-drawer><details class="cart-drawer-container">
  // y el contenido vive en <mini-cart>, que se carga por fetch al abrir y reemplaza
  // todo su interior. Por eso la nota se inserta DENTRO de mini-cart y se vuelve a
  // poner cada vez que ese contenido cambia. Fuera de ahi queda suelta en la pagina.
  function cajonAbierto() {
    return !!document.querySelector("details.cart-drawer-container[open], cart-drawer details[open]");
  }

  // El cajon tiene contenedores propios: .mini-cart__main es el area con scroll donde
  // viven los articulos, y .mini-cart__footer tiene el boton de pago. La nota va dentro
  // del main, arriba de los articulos: asi no toca el pie y el scroll sigue funcionando.
  // El cajon tiene su propio bloque de avisos en el pie, junto al boton de pago
  // (.taxes-discounts, que ya contiene "Taxes and shipping calculated at checkout").
  // La nota va ahi como un texto mas del tema: sin cajas flotantes ni elementos sueltos.
  function destinoCajon() {
    var mc = document.querySelector("mini-cart#mini-cart, cart-drawer mini-cart, mini-cart.cart-drawer");
    if (!mc) return null;
    var bloque = mc.querySelector(".mini-cart__footer .taxes-discounts, .taxes-discounts");
    if (bloque) return { contenedor: bloque, antesDe: null };
    var pie = mc.querySelector(".mini-cart__footer, .cart-drawer__footer, .drawer__footer");
    if (pie) return { contenedor: pie, antesDe: pie.querySelector("[class*='taxes'], [class*='total']") };
    return null;
  }

  function pintarNotaCarrito() {
    var existente = document.querySelector("[data-kav-moneda-nota]");
    var mc = document.querySelector("mini-cart#mini-cart, cart-drawer mini-cart, mini-cart.cart-drawer");

    // limpiar cualquier nota que haya quedado fuera del cajon o de la pagina del carrito
    if (existente && !(mc && mc.contains(existente)) && !/\/cart(\/|$|\?)/.test(location.pathname)) {
      existente.remove(); existente = null;
    }
    if (monedaActiva === MONEDA_TIENDA) { if (existente) existente.remove(); return; }

    var enPaginaCarrito = /\/cart(\/|$|\?)/.test(location.pathname);
    var destino = null, antesDe = null;

    if (enPaginaCarrito) {
      antesDe = document.querySelector("form[action*='/cart'], cart-items, [data-cart-form], #cart-form, .cart__form, .cart__contents");
      if (antesDe && antesDe.parentNode) destino = antesDe.parentNode;
      if (!destino && mc) { destino = mc; }
    } else if (cajonAbierto()) {
      var d = destinoCajon();
      if (d) { destino = d.contenedor; antesDe = d.antesDe; }
    }

    if (!destino) { if (existente) existente.remove(); return; }

    var nota = existente || document.createElement("p");
    nota.setAttribute("data-kav-moneda-nota", "1");
    nota.setAttribute("data-moneda", monedaActiva);
    nota.textContent = textoNota();
    nota.style.cssText = "margin:0 0 8px;font-size:12px;line-height:1.45;color:#333333";
    if (antesDe && antesDe.parentNode === destino) destino.insertBefore(nota, antesDe);
    else if (!existente || existente.parentNode !== destino) destino.insertBefore(nota, destino.firstChild);
  }

  function textoNota() {
    var nombre = NOMBRE[monedaActiva] || monedaActiva;
    return "While the content of your cart is currently displayed in " + nombre + ", you will checkout using US Dollar at the most current exchange rate.";
  }

  function aplicar(moneda) {
    if (moneda && !/^[A-Z]{3}$/.test(moneda)) moneda = null;
    monedaActiva = moneda || MONEDA_TIENDA;
    monedaActiva = monedaActiva.toUpperCase();
    if (!tasas) {
      var cache = leer(CLAVE_TASAS);
      if (cache && cache.tasas) tasas = cache.tasas;
      cargarTasas();
    }
    recorrer();
    pintarPromo();
    pintarNotaCarrito();
    actualizarBoton();
    observar();
    // avisa a la linea de envio de la ficha que la moneda cambio
    try { document.dispatchEvent(new CustomEvent("kav:moneda")); } catch (e) {}
  }

  function cargarTasas(forzar) {
    var cache = leer(CLAVE_TASAS);
    var ahora = Date.now();
    if (!forzar && cache && cache.tasas && (ahora - (cache.cuando || 0)) < HORAS_CACHE * 3600 * 1000) {
      tasas = cache.tasas; recorrer(); return;
    }
    fetch(API_TASAS, { cache: "no-store", referrerPolicy: "no-referrer" })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var t = d && (d.rates || d.conversion_rates);
        if (!t) return;
        tasas = t;
        guardar(CLAVE_TASAS, { cuando: ahora, tasas: t });
        // La lista del selector es curada a mano. Solo agregamos la moneda activa,
        // por si quedo guardada una que ya no figura en la lista.
        if (monedaActiva && MONEDAS.indexOf(monedaActiva) === -1) ampliarMonedas([monedaActiva]);
        recorrer(); pintarNotaCarrito();
      })
      .catch(function () {});
  }

  function observar() {
    if (observando || !window.MutationObserver) return;
    observando = true;
    var pendiente = null;
    var obs = new MutationObserver(function (cambios) {
      var relevante = false;
      for (var i = 0; i < cambios.length; i++) {
        var c = cambios[i];
        if (c.target && c.target.closest && c.target.closest("[data-kav-moneda-ui]")) continue;
        if (c.type === "childList" || c.type === "characterData") { relevante = true; break; }
      }
      if (!relevante) return;
      if (pendiente) clearTimeout(pendiente);
      pendiente = setTimeout(function () { recorrer(); pintarNotaCarrito(); }, 180);
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- selector ---------- */
  function actualizarBoton() {
    var codigo = monedaActiva || MONEDA_TIENDA;
    var el = document.querySelector("[data-kav-moneda-codigo]");
    if (el) el.textContent = codigo;
    var fl = document.querySelector("[data-kav-moneda-bandera]");
    if (fl) fl.textContent = BANDERA[codigo] || "🏳️";
    var lista = document.querySelector("[data-kav-moneda-panel]");
    if (lista) {
      var ops = lista.querySelectorAll("[data-moneda-op]");
      for (var i = 0; i < ops.length; i++) {
        var m = ops[i].getAttribute("data-moneda-op");
        ops[i].setAttribute("aria-selected", m === monedaActiva ? "true" : "false");
        ops[i].style.fontWeight = m === monedaActiva ? "700" : "400";
      }
    }
  }

  // todas las monedas que responde la fuente de tasas, sin repetir las que ya estan
  function ampliarMonedas(codigos) {
    if (!codigos || !codigos.length) return;
    var agregadas = [];
    for (var i = 0; i < codigos.length; i++) {
      var c = String(codigos[i] || "").toUpperCase();
      if (c && c.length === 3 && MONEDAS.indexOf(c) === -1) { MONEDAS.push(c); agregadas.push(c); }
    }
    if (!agregadas.length) return;
    completarSimbolos(agregadas);
    agregadas.sort();
    var panel = document.querySelector("[data-kav-moneda-panel]");
    if (panel) {
      for (var k = 0; k < agregadas.length; k++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("data-moneda-op", agregadas[k]);
        b.innerHTML = '<span class="kav-moneda-fl">' + (BANDERA[agregadas[k]] || "🏳️") + "</span>" + agregadas[k];
        panel.appendChild(b);
      }
      actualizarBoton();
    }
  }

  // Simbolos de las divisas que el navegador devuelve solo como codigo.
  var SIMBOLO_EXTRA = {
    "ZAR":"R ", "TRY":"\u20ba", "PLN":"z\u0142 ", "CZK":"K\u010d ", "HUF":"Ft ", "THB":"\u0e3f",
    "IDR":"Rp ", "MYR":"RM ", "VND":"\u20ab ", "ILS":"\u20aa", "NGN":"\u20a6", "KES":"KSh ",
    "GHS":"GH\u20b5", "MAD":"DH ", "TND":"DT ", "DZD":"DA ", "EGP":"E\u00a3 ", "PKR":"Rs ",
    "LKR":"Rs ", "NPR":"Rs ", "BDT":"\u09f3", "UAH":"\u20b4", "KZT":"\u20b8", "GEL":"\u20be",
    "AZN":"\u20bc", "AMD":"\u058f", "RSD":"din ", "BGN":"\u043b\u0432 ", "RON":"lei ", "HRK":"kn ",
    "ISK":"kr ", "NOK":"kr ", "DKK":"kr ", "SEK":"kr ", "RUB":"\u20bd", "BYN":"Br ", "MXN":"MX$",
    "PYG":"\u20b2", "UYU":"$U ", "BOB":"Bs ", "TWD":"NT$", "KWD":"KD ", "QAR":"QR ", "SAR":"SR "
  };
  for (var _sc in SIMBOLO_EXTRA) { if (SIMBOLO[_sc] === undefined) SIMBOLO[_sc] = SIMBOLO_EXTRA[_sc]; }

  // Banderas para el resto de las monedas que ofrece la lista de tasas.
  var BANDERA_EXTRA = {
    "AED":"\uD83C\uDDE6\uD83C\uDDEA","AFN":"\uD83C\uDDE6\uD83C\uDDEB","ALL":"\uD83C\uDDE6\uD83C\uDDF1","AMD":"\uD83C\uDDE6\uD83C\uDDF2","ANG":"\uD83C\uDDE8\uD83C\uDDFC","AOA":"\uD83C\uDDE6\uD83C\uDDF4","ARS":"\uD83C\uDDE6\uD83C\uDDF7","AWG":"\uD83C\uDDE6\uD83C\uDDFC","AZN":"\uD83C\uDDE6\uD83C\uDDFF",
    "BAM":"\uD83C\uDDE7\uD83C\uDDE6","BBD":"\uD83C\uDDE7\uD83C\uDDE7","BDT":"\uD83C\uDDE7\uD83C\uDDE9","BGN":"\uD83C\uDDE7\uD83C\uDDEC","BHD":"\uD83C\uDDE7\uD83C\uDDED","BIF":"\uD83C\uDDE7\uD83C\uDDEE","BMD":"\uD83C\uDDE7\uD83C\uDDF2","BND":"\uD83C\uDDE7\uD83C\uDDF3","BOB":"\uD83C\uDDE7\uD83C\uDDF4","BRL":"\uD83C\uDDE7\uD83C\uDDF7","BSD":"\uD83C\uDDE7\uD83C\uDDF8","BTN":"\uD83C\uDDE7\uD83C\uDDF9","BWP":"\uD83C\uDDE7\uD83C\uDDFC","BYN":"\uD83C\uDDE7\uD83C\uDDFE","BZD":"\uD83C\uDDE7\uD83C\uDDFF",
    "CDF":"\uD83C\uDDE8\uD83C\uDDE9","CUP":"\uD83C\uDDE8\uD83C\uDDFA","CVE":"\uD83C\uDDE8\uD83C\uDDFB","CZK":"\uD83C\uDDE8\uD83C\uDDFF",
    "DJF":"\uD83C\uDDE9\uD83C\uDDEF","DZD":"\uD83C\uDDE9\uD83C\uDDFF",
    "EGP":"\uD83C\uDDEA\uD83C\uDDEC","ERN":"\uD83C\uDDEA\uD83C\uDDF7","ETB":"\uD83C\uDDEA\uD83C\uDDF9",
    "FJD":"\uD83C\uDDEB\uD83C\uDDEF","FKP":"\uD83C\uDDEB\uD83C\uDDF0",
    "GEL":"\uD83C\uDDEC\uD83C\uDDEA","GGP":"\uD83C\uDDEC\uD83C\uDDEC","GHS":"\uD83C\uDDEC\uD83C\uDDED","GIP":"\uD83C\uDDEC\uD83C\uDDEE","GMD":"\uD83C\uDDEC\uD83C\uDDF2","GNF":"\uD83C\uDDEC\uD83C\uDDF3","GTQ":"\uD83C\uDDEC\uD83C\uDDF9",
    "HKD":"\uD83C\uDDED\uD83C\uDDF0","HNL":"\uD83C\uDDED\uD83C\uDDF3","HTG":"\uD83C\uDDED\uD83C\uDDF9","HUF":"\uD83C\uDDED\uD83C\uDDFA",
    "IDR":"\uD83C\uDDEE\uD83C\uDDE9","ILS":"\uD83C\uDDEE\uD83C\uDDF1","IMP":"\uD83C\uDDEE\uD83C\uDDF2","INR":"\uD83C\uDDEE\uD83C\uDDF3","IQD":"\uD83C\uDDEE\uD83C\uDDF6","IRR":"\uD83C\uDDEE\uD83C\uDDF7","ISK":"\uD83C\uDDEE\uD83C\uDDF8",
    "JEP":"\uD83C\uDDEF\uD83C\uDDEA","JMD":"\uD83C\uDDEF\uD83C\uDDF2","JOD":"\uD83C\uDDEF\uD83C\uDDF4",
    "KES":"\uD83C\uDDF0\uD83C\uDDEA","KGS":"\uD83C\uDDF0\uD83C\uDDEC","KHR":"\uD83C\uDDF0\uD83C\uDDED","KMF":"\uD83C\uDDF0\uD83C\uDDF2","KRW":"\uD83C\uDDF0\uD83C\uDDF7","KWD":"\uD83C\uDDF0\uD83C\uDDFC","KYD":"\uD83C\uDDF0\uD83C\uDDFE","KZT":"\uD83C\uDDF0\uD83C\uDDFF",
    "LAK":"\uD83C\uDDF1\uD83C\uDDE6","LBP":"\uD83C\uDDF1\uD83C\uDDE7","LKR":"\uD83C\uDDF1\uD83C\uDDF0","LRD":"\uD83C\uDDF1\uD83C\uDDF7","LSL":"\uD83C\uDDF1\uD83C\uDDF8","LYD":"\uD83C\uDDF1\uD83C\uDDFE",
    "MAD":"\uD83C\uDDF2\uD83C\uDDE6","MDL":"\uD83C\uDDF2\uD83C\uDDE9","MGA":"\uD83C\uDDF2\uD83C\uDDEC","MKD":"\uD83C\uDDF2\uD83C\uDDF0","MMK":"\uD83C\uDDF2\uD83C\uDDF2","MNT":"\uD83C\uDDF2\uD83C\uDDF3","MOP":"\uD83C\uDDF2\uD83C\uDDF4","MRU":"\uD83C\uDDF2\uD83C\uDDF7","MUR":"\uD83C\uDDF2\uD83C\uDDFA","MVR":"\uD83C\uDDF2\uD83C\uDDFB","MWK":"\uD83C\uDDF2\uD83C\uDDFC","MYR":"\uD83C\uDDF2\uD83C\uDDFE","MZN":"\uD83C\uDDF2\uD83C\uDDFF",
    "NAD":"\uD83C\uDDF3\uD83C\uDDE6","NGN":"\uD83C\uDDF3\uD83C\uDDEC","NOK":"\uD83C\uDDF3\uD83C\uDDF4","NPR":"\uD83C\uDDF3\uD83C\uDDF5",
    "OMR":"\uD83C\uDDF4\uD83C\uDDF2",
    "PEN":"\uD83C\uDDF5\uD83C\uDDEA","PGK":"\uD83C\uDDF5\uD83C\uDDEC","PHP":"\uD83C\uDDF5\uD83C\uDDED","PKR":"\uD83C\uDDF5\uD83C\uDDF0","PLN":"\uD83C\uDDF5\uD83C\uDDF1","PYG":"\uD83C\uDDF5\uD83C\uDDFE",
    "QAR":"\uD83C\uDDF6\uD83C\uDDE6",
    "RON":"\uD83C\uDDF7\uD83C\uDDF4","RSD":"\uD83C\uDDF7\uD83C\uDDF8","RUB":"\uD83C\uDDF7\uD83C\uDDFA","RWF":"\uD83C\uDDF7\uD83C\uDDFC",
    "SAR":"\uD83C\uDDF8\uD83C\uDDE6","SBD":"\uD83C\uDDF8\uD83C\uDDE7","SCR":"\uD83C\uDDF8\uD83C\uDDE8","SDG":"\uD83C\uDDF8\uD83C\uDDE9","SEK":"\uD83C\uDDF8\uD83C\uDDEA","SGD":"\uD83C\uDDF8\uD83C\uDDEC","SHP":"\uD83C\uDDF8\uD83C\uDDED","SLE":"\uD83C\uDDF8\uD83C\uDDF1","SLL":"\uD83C\uDDF8\uD83C\uDDF1","SOS":"\uD83C\uDDF8\uD83C\uDDF4","SRD":"\uD83C\uDDF8\uD83C\uDDF7","SSP":"\uD83C\uDDF8\uD83C\uDDF8","STN":"\uD83C\uDDF8\uD83C\uDDF9","SYP":"\uD83C\uDDF8\uD83C\uDDFE","SZL":"\uD83C\uDDF8\uD83C\uDDFF",
    "THB":"\uD83C\uDDF9\uD83C\uDDED","TJS":"\uD83C\uDDF9\uD83C\uDDEF","TMT":"\uD83C\uDDF9\uD83C\uDDF2","TND":"\uD83C\uDDF9\uD83C\uDDF3","TOP":"\uD83C\uDDF9\uD83C\uDDF4","TRY":"\uD83C\uDDF9\uD83C\uDDF7","TTD":"\uD83C\uDDF9\uD83C\uDDF9","TWD":"\uD83C\uDDF9\uD83C\uDDFC","TZS":"\uD83C\uDDF9\uD83C\uDDFF",
    "UAH":"\uD83C\uDDFA\uD83C\uDDE6","UGX":"\uD83C\uDDFA\uD83C\uDDEC","UYU":"\uD83C\uDDFA\uD83C\uDDFE","UZS":"\uD83C\uDDFA\uD83C\uDDFF",
    "VES":"\uD83C\uDDFB\uD83C\uDDEA","VND":"\uD83C\uDDFB\uD83C\uDDF3","VUV":"\uD83C\uDDFB\uD83C\uDDFA",
    "WST":"\uD83C\uDDFC\uD83C\uDDF8",
    "XAF":"\uD83C\uDF0D","XCD":"\uD83C\uDF34","XOF":"\uD83C\uDF0D","XPF":"\uD83C\uDF34",
    "YER":"\uD83C\uDDFE\uD83C\uDDEA",
    "ZAR":"\uD83C\uDDFF\uD83C\uDDE6","ZMW":"\uD83C\uDDFF\uD83C\uDDF2",
    "CLF":"\uD83C\uDDE8\uD83C\uDDF1","HRK":"\uD83C\uDDED\uD83C\uDDF7","KID":"\uD83C\uDDF0\uD83C\uDDEE","TVD":"\uD83C\uDDF9\uD83C\uDDFB",
    "FOK":"\uD83C\uDDEB\uD83C\uDDF4","XCG":"\uD83C\uDDE8\uD83C\uDDFC","XDR":"\uD83C\uDFE6","ZWG":"\uD83C\uDDFF\uD83C\uDDFC","ZWL":"\uD83C\uDDFF\uD83C\uDDFC"
  };
  for (var _bc in BANDERA_EXTRA) { if (BANDERA[_bc] === undefined) BANDERA[_bc] = BANDERA_EXTRA[_bc]; }

  // Simbolos: la tabla de arriba cubre las mas usadas; para el resto lo tomamos
  // del propio navegador (Intl), que ya trae el simbolo oficial de cada divisa.
  function completarSimbolos(codigos) {
    if (!window.Intl || !Intl.NumberFormat || !Intl.NumberFormat.prototype.formatToParts) return;
    for (var i = 0; i < codigos.length; i++) {
      var c = codigos[i];
      if (SIMBOLO[c] !== undefined) continue;
      try {
        var partes = new Intl.NumberFormat("en", { style: "currency", currency: c }).formatToParts(0);
        for (var j = 0; j < partes.length; j++) {
          if (partes[j].type === "currency") {
            var sim = String(partes[j].value || "").trim();
            if (sim && sim !== c) SIMBOLO[c] = sim + " ";
            break;
          }
        }
      } catch (e) {}
    }
  }

  /* ---------- selector de idioma ----------
     Shopify emite una etiqueta hreflang por idioma publicado, asi que de ahi
     salen los idiomas disponibles. El cambio usa el mecanismo oficial de la
     plataforma: un formulario a /localization, que deja la cookie y redirige. */
  var NOMBRE_IDIOMA = { en: "English", es: "Espa\u00f1ol", fr: "Fran\u00e7ais", pt: "Portugu\u00eas",
                        de: "Deutsch", it: "Italiano", nl: "Nederlands", ja: "\u65e5\u672c\u8a9e" };

  function idiomasDisponibles() {
    var forzado = (location.search.match(/[?&]kavidiomas=([A-Za-z,\-]{2,60})/) || [])[1];
    var set = {};
    if (forzado) {
      forzado.split(",").forEach(function (x) {
        var c = x.trim().split("-")[0].toLowerCase();
        if (/^[a-z]{2}$/.test(c)) set[c] = 1;
      });
      return Object.keys(set).sort();
    }
    idiomasPublicados().forEach(function (c) { set[c] = 1; });
    IDIOMAS_CON_AVISOS.forEach(function (c) { set[c] = 1; });
    return Object.keys(set).sort();
  }

  function idiomaActual() {
    // mismo criterio que los textos: el forzado de prueba manda
    return idiomaActivo();
  }

  function cambiarIdioma(codigo) {
    if (!codigo) return;
    // Si Shopify ya publico el idioma, cambiamos todo el sitio con su formulario oficial.
    if (idiomasPublicados().indexOf(codigo) > -1) {
      try { localStorage.removeItem(CLAVE_IDIOMA); } catch (e) {}
      // dejamos la pagina consistente ya mismo, y ademas pedimos el cambio al sitio
      refrescarIdioma();
      var f0 = document.createElement("form");
    f.method = "post";
    f.action = "/localization";
    f.acceptCharset = "UTF-8";
    f.style.display = "none";
      var campos = { form_type: "localization", utf8: "\u2713", _method: "put",
                     return_to: location.pathname + location.search, language_code: codigo };
      for (var k in campos) {
        var i2 = document.createElement("input");
        i2.type = "hidden"; i2.name = k; i2.value = campos[k];
        f0.appendChild(i2);
      }
      document.body.appendChild(f0);
      f0.submit();
      return;
    }
    // Todavia no publicado: se aplica local, cambian los avisos que controlamos.
    guardar(CLAVE_IDIOMA, codigo);
    refrescarIdioma();
  }

  function montarIdiomas(panel) {
    var idiomas = idiomasDisponibles();
    var forzado = /[?&]kavidiomas=/i.test(location.search);
    if (idiomas.length < 2 && !forzado) return false;
    var bloque = document.createElement("div");
    bloque.setAttribute("data-kav-idiomas", "1");
    var etiqueta = document.createElement("p");
    etiqueta.className = "kav-idiomas__t";
    etiqueta.innerHTML = '<svg class="kav-idiomas__ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M3 12h18M12 3c2.6 2.7 2.6 15.3 0 18M12 3c-2.6 2.7-2.6 15.3 0 18"></path></svg><span>Language</span>';
    bloque.appendChild(etiqueta);
    var fila = document.createElement("div");
    fila.className = "kav-idiomas__fila";
    var actual = idiomaActual();
    for (var i = 0; i < idiomas.length; i++) {
      (function (cod) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("data-idioma-op", cod);
        b.textContent = NOMBRE_IDIOMA[cod] || cod.toUpperCase();
        if (cod === actual) b.setAttribute("aria-selected", "true");
        b.addEventListener("click", function (ev) { ev.stopPropagation(); cambiarIdioma(cod); });
        fila.appendChild(b);
      })(idiomas[i]);
    }
    bloque.appendChild(fila);
    panel.appendChild(bloque);
    var sep = document.createElement("div");
    sep.className = "kav-idiomas__sep";
    panel.appendChild(sep);
    return true;
  }

  function montarUI() {
    if (document.querySelector("[data-kav-moneda-ui]")) return;
    completarSimbolos(MONEDAS);
    var cont = document.createElement("div");
    cont.setAttribute("data-kav-moneda-ui", "1");

    var btn = document.createElement("button");
    btn.type = "button";
    btn.setAttribute("data-kav-moneda-btn", "1");
    btn.setAttribute("aria-expanded", "false");
    btn.innerHTML = '<span data-kav-moneda-bandera>🇺🇸</span><span data-kav-moneda-codigo>USD</span><span class="kav-moneda-caret">▾</span>';

    var panel = document.createElement("div");
    panel.setAttribute("data-kav-moneda-panel", "1");
    var auto = document.createElement("button");
    auto.type = "button";
    auto.setAttribute("data-moneda-op", "");
    auto.textContent = "Automatic (by location)";
    montarIdiomas(panel);
    panel.appendChild(auto);
    for (var i = 0; i < MONEDAS.length; i++) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("data-moneda-op", MONEDAS[i]);
      b.innerHTML = '<span class="kav-moneda-fl">' + (BANDERA[MONEDAS[i]] || "🏳️") + "</span>" + MONEDAS[i];
      panel.appendChild(b);
    }

    cont.appendChild(btn);
    cont.appendChild(panel);
    document.body.appendChild(cont);

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      var abierto = cont.getAttribute("data-abierto") === "1";
      cont.setAttribute("data-abierto", abierto ? "0" : "1");
      btn.setAttribute("aria-expanded", abierto ? "false" : "true");
    });
    panel.addEventListener("click", function (e) {
      var op = e.target.closest("[data-moneda-op]");
      if (!op) return;
      var m = op.getAttribute("data-moneda-op");
      if (m) { guardar(CLAVE_GUARDADA, m); aplicar(m); }
      else { try { localStorage.removeItem(CLAVE_GUARDADA); } catch (err) {} detectarPorIP(true); }
      cont.setAttribute("data-abierto", "0");
      btn.setAttribute("aria-expanded", "false");
    });
    document.addEventListener("click", function () {
      cont.setAttribute("data-abierto", "0");
      btn.setAttribute("aria-expanded", "false");
    });
    actualizarBoton();
  }

  /* ---------- promo de envio por pais ----------
     La barra de anuncios del tema trae dos textos fijos. Este bloque reescribe el
     de envio segun el pais del visitante, con los umbrales y tarifas que la tienda
     aplica de verdad en el checkout (los mismos de la pagina de politica de envio). */
  var CLAVE_PAIS = "kav_pais";
  var HORAS_PAIS = 12;
  var paisActual = null;

  var PROMO_PAIS = {
    "US": "Free Shipping on U.S. Orders Over $200",
    "CA": "Free Shipping to Canada Over $250",
    "CR": "Free Shipping on Costa Rica Orders Over $100",
    "MX": "Shipping to Mexico from $14.90",
    "GB": "Shipping to the UK from $29.90"
  };
  var PROMO_ZONA = {
    "CENTROAMERICA": "Shipping to Central America from $14.90",
    "EUROPA": "Shipping to Europe from $24.90",
    "ASIA": "Shipping to Asia from $29.90",
    "OCEANIA": "Shipping to Australia from $24.90",
    "SUDAMERICA": "Shipping to South America from $19.90"
  };
  var PROMO_DEFECTO = "Worldwide Shipping \u00b7 Rates at Checkout";
  // Cada moneda del selector apunta a su promo. Asi el aviso acompana al selector.
  // Versiones en espanol de los mismos avisos. Se eligen segun el idioma activo.
  var PROMO_PAIS_ES = {
    "US": "Env\u00edo gratis en pedidos a EE. UU. desde $200",
    "CA": "Env\u00edo gratis a Canad\u00e1 en pedidos desde $250",
    "CR": "Env\u00edo gratis en pedidos a Costa Rica desde $100",
    "MX": "Env\u00edo a M\u00e9xico desde $14.90",
    "GB": "Env\u00edo al Reino Unido desde $29.90"
  };
  var PROMO_ZONA_ES = {
    "CENTROAMERICA": "Env\u00edo a Centroam\u00e9rica desde $14.90",
    "EUROPA": "Env\u00edo a Europa desde $24.90",
    "ASIA": "Env\u00edo a Asia desde $29.90",
    "OCEANIA": "Env\u00edo a Australia desde $24.90",
    "SUDAMERICA": "Env\u00edo a Sudam\u00e9rica desde $19.90"
  };
  var PROMO_DEFECTO_ES = "Env\u00edo mundial \u00b7 tarifas al finalizar la compra";

  var PROMO_MONEDA = {
    "USD": "US", "CRC": "CR", "CAD": "CA", "MXN": "MX", "GBP": "GB",
    "GTQ": "CENTROAMERICA", "HNL": "CENTROAMERICA", "NIO": "CENTROAMERICA", "PAB": "CENTROAMERICA", "DOP": "CENTROAMERICA",
    "BRL": "SUDAMERICA", "COP": "SUDAMERICA", "PEN": "SUDAMERICA", "CLP": "SUDAMERICA", "ARS": "SUDAMERICA",
    "PYG": "SUDAMERICA", "UYU": "SUDAMERICA", "BOB": "SUDAMERICA",
    "EUR": "EUROPA", "CHF": "EUROPA", "SEK": "EUROPA", "NOK": "EUROPA", "DKK": "EUROPA", "PLN": "EUROPA",
    "CZK": "EUROPA", "HUF": "EUROPA", "RON": "EUROPA", "BGN": "EUROPA", "TRY": "EUROPA",
    "AUD": "OCEANIA", "NZD": "OCEANIA",
    "JPY": "ASIA", "KRW": "ASIA", "CNY": "ASIA", "HKD": "ASIA", "SGD": "ASIA", "TWD": "ASIA", "THB": "ASIA",
    "MYR": "ASIA", "IDR": "ASIA", "PHP": "ASIA", "INR": "ASIA", "VND": "ASIA",
    "AED": "ASIA", "SAR": "ASIA", "QAR": "ASIA", "ILS": "ASIA", "KWD": "ASIA"
  };
  var ZONA_GRUPOS = {
    "CENTROAMERICA": "GT HN NI PA SV BZ",
    "ASIA": "CN HK SG TW KR IN JP TH MY ID PH VN AE SA QA IL KW PK BD LK NP KH LA MM MN MO BN",
    "OCEANIA": "AU NZ PG FJ NC PF SB VU WS TO",
    "SUDAMERICA": "AR BO BR CL CO EC GY PY PE SR UY VE"
  };

  // Idiomas que tienen avisos traducidos. Se ofrecen aunque Shopify todavia no
  // los tenga publicados: en ese caso el cambio se aplica solo a los avisos.
  var IDIOMAS_CON_AVISOS = ["en", "es"];
  var CLAVE_IDIOMA = "kav_idioma";

  function idiomaElegido() {
    var v = leer(CLAVE_IDIOMA);
    v = String(v == null ? "" : v).replace(/^"|"$/g, "").toLowerCase();
    return /^[a-z]{2}$/.test(v) ? v : null;
  }

  function idiomasPublicados() {
    var set = {};
    var ls = document.querySelectorAll("link[hreflang], a[hreflang]");
    for (var i = 0; i < ls.length; i++) {
      var v = String(ls[i].getAttribute("hreflang") || "").toLowerCase();
      if (!v || v === "x-default") continue;
      var c = v.split("-")[0];
      if (/^[a-z]{2}$/.test(c)) set[c] = 1;
    }
    if (window.Shopify && Shopify.locale) {
      var a = String(Shopify.locale).toLowerCase().split("-")[0];
      if (/^[a-z]{2}$/.test(a)) set[a] = 1;
    }
    return Object.keys(set).sort();
  }

  // Idioma activo: el forzado con ?kavidioma=xx, la eleccion guardada, o el de Shopify.
  function idiomaActivo() {
    var forzado = (location.search.match(/[?&]kavidioma=([A-Za-z]{2})/) || [])[1];
    if (forzado) return forzado.toLowerCase();
    var elegido = idiomaElegido();
    if (elegido) return elegido;
    var l = (window.Shopify && Shopify.locale) ? String(Shopify.locale) : (document.documentElement.lang || "en");
    return l.toLowerCase().split("-")[0];
  }

  // Refresca las pildoras del switch y avisa a la linea de la ficha.
  function refrescarIdioma() {
    var actual = idiomaActivo();
    var ops = document.querySelectorAll("[data-idioma-op]");
    for (var i = 0; i < ops.length; i++) {
      var m = ops[i].getAttribute("data-idioma-op");
      if (m === actual) ops[i].setAttribute("aria-selected", "true");
      else ops[i].removeAttribute("aria-selected");
    }
    pintarPromo();
    try { document.dispatchEvent(new CustomEvent("kav:idioma")); } catch (e) {}
  }
  function esEspanol() { return idiomaActivo() === "es"; }
  function textoPais(pais) {
    var t = esEspanol() ? PROMO_PAIS_ES : PROMO_PAIS;
    return t[pais] || null;
  }
  function textoZona(zona) {
    var t = esEspanol() ? PROMO_ZONA_ES : PROMO_ZONA;
    return t[zona] || null;
  }

  function zonaDe(pais) {
    if (!pais) return null;
    if (EUROPA.indexOf(pais) > -1) return "EUROPA";
    for (var z in ZONA_GRUPOS) {
      if (ZONA_GRUPOS[z].indexOf(pais) > -1) return z;
    }
    return null;
  }

  function textoPromo(pais) {
    var def = esEspanol() ? PROMO_DEFECTO_ES : PROMO_DEFECTO;
    if (!pais) return def;
    var directo = textoPais(pais);
    if (directo) return directo;
    var z = zonaDe(pais);
    return (z && textoZona(z)) ? textoZona(z) : def;
  }

  function textoPromoMoneda(moneda) {
    var def = esEspanol() ? PROMO_DEFECTO_ES : PROMO_DEFECTO;
    var clave = PROMO_MONEDA[moneda];
    if (!clave) return def;
    return textoPais(clave) || textoZona(clave) || def;
  }

  // Si el visitante eligio moneda, manda su eleccion: el aviso va con el selector.
  // Si no eligio nada, se usa el pais detectado (que es el que fijo la moneda inicial).
  function textoPromoVigente() {
    if (leerGuardada() && monedaActiva) return textoPromoMoneda(monedaActiva);
    if (paisActual) return textoPromo(paisActual);
    return textoPromoMoneda(monedaActiva);
  }

  // Reescribe el texto de envio de la barra. El tema lo parte en dos spans
  // (escritorio y movil) y rota dos mensajes: tocamos el de envio, no el otro.
  function pintarPromo() {
    var texto = textoPromoVigente();
    if (!texto) return;
    var slides = document.querySelectorAll(".announcement-slider__slide");
    if (!slides.length) return;
    var objetivo = null;
    for (var i = 0; i < slides.length; i++) {
      var t = (slides[i].textContent || "");
      if (/ship/i.test(t) && !/worldwide/i.test(t)) { objetivo = slides[i]; break; }
    }
    if (!objetivo) objetivo = slides[0];
    var spans = objetivo.querySelectorAll("span");
    var lista = spans.length ? spans : [objetivo];
    for (var j = 0; j < lista.length; j++) {
      var el = lista[j];
      if (el.getAttribute("data-kav-promo") === texto) continue;
      el.textContent = texto;
      el.setAttribute("data-kav-promo", texto);
      el.removeAttribute("data-kav-usd");
    }
  }

  // Pais del visitante: parametro de prueba, luego cache, luego IP.
  function paisDeIP(cb, forzar) {
    var forzado = (location.search.match(/[?&]kavpais=([A-Za-z]{2})/) || [])[1];
    if (forzado) { paisActual = forzado.toUpperCase(); cb(paisActual); return; }
    var cache = leer(CLAVE_PAIS);
    if (!forzar && cache && cache.codigo && (Date.now() - (cache.cuando || 0)) < HORAS_PAIS * 3600 * 1000) {
      paisActual = cache.codigo; cb(paisActual); return;
    }
    fetch(API_IP, { cache: "no-store", referrerPolicy: "no-referrer" })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = String((d && (d.country_code || d.country)) || "").toUpperCase();
        if (/^[A-Z]{2}$/.test(c)) {
          paisActual = c;
          guardar(CLAVE_PAIS, { cuando: Date.now(), codigo: c });
          cb(c);
        }
      })
      .catch(function () {});
  }

  function detectarPorIP(forzar) {
    paisDeIP(function (pais) {
      var m = monedaPorPais(pais);
      // si el IP cae en el dolar pero el navegador dice otro pais, gana el navegador
      if (!m || m === "USD") {
        var alt = monedaPorNavegador();
        if (alt) m = alt;
      }
      aplicar(m || MONEDA_TIENDA);
    }, forzar);
  }

  function arrancar() {
    // cuando el tema abre el cajon, su contenido se carga por fetch: reintentamos varias veces
    ["cartdrawer:opened", "cart:updated"].forEach(function (ev) {
      document.addEventListener(ev, function () {
        [80, 300, 700, 1300].forEach(function (t) {
          setTimeout(function () { pintarNotaCarrito(); }, t);
        });
      });
    });
    montarUI();
    var forzada = (location.search.match(/[?&]kavmoneda=([A-Za-z]{3})/) || [])[1];
    if (forzada) {
      var fz = forzada.toUpperCase();
      guardar(CLAVE_GUARDADA, fz);
      aplicar(fz);
    } else {
      var guardada = leerGuardada();
      // la eleccion del usuario gana sobre la deteccion por IP, siempre
      if (guardada) aplicar(guardada);
    }
    // El pais se resuelve en cada pagina: de ahi sale la promo de envio y, si el
    // visitante no eligio moneda, tambien la moneda.
    paisDeIP(function (pais) {
      pintarPromo();
      if (!forzada && !leerGuardada()) {
        var m2 = monedaPorPais(pais);
        if (!m2 || m2 === "USD") {
          var alt = monedaPorNavegador();
          if (alt) m2 = alt;
        }
        aplicar(m2 || MONEDA_TIENDA);
      }
    });
    cargarTasas();
    // el carrito y las variantes se reescriben seguido: repasamos cada tanto
    setInterval(function () { pintarPromo(); recorrer(); }, 2500);
  }


  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arrancar);
  else arrancar();
})();
